module.exports = __webpack_public_path__ + "img/agentinstsecond.bd287570.png";